import {
  ModuleStoreState,
  moduleVersionIsNewer,
  type ModuleStoreCard,
} from '@gb-ticket/shared-types';

/** Short status line for a store / setup card (German UI). */
export function moduleStoreStatusLabel(card: ModuleStoreCard): string {
  if (card.state === ModuleStoreState.PLANNED) {
    return 'Noch nicht verfügbar';
  }
  if (card.state === ModuleStoreState.REMOVED) {
    return 'Entfernt, Daten bleiben';
  }
  if (card.state === ModuleStoreState.INSTALLED) {
    const installed = card.installedVersion ?? card.version;
    if (
      card.installedVersion &&
      card.version &&
      moduleVersionIsNewer(card.installedVersion, card.version)
    ) {
      return `Installiert ${card.installedVersion} · Katalog ${card.version}`;
    }
    return installed ? `Installiert · ${installed}` : 'Installiert';
  }
  return card.version ? `Version ${card.version}` : '';
}

export function moduleNeedsUpgrade(card: ModuleStoreCard): boolean {
  return (
    card.state === ModuleStoreState.INSTALLED &&
    Boolean(card.installedVersion && card.version) &&
    moduleVersionIsNewer(card.installedVersion!, card.version!)
  );
}
